import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import splitLongWords from 'utils/splitLongWords';

import OrderViewInformationSection from './OrderViewInformationSection';
import OrderViewInformationSectionTitle from './OrderViewInformationSectionTitle';

const OrderViewInformationGeneral = ({
  Facility,
  ...otherProps
}) => (
  <OrderViewInformationSection>
    <Grid
      container
      direction="column"
      justify="flex-start"
      spacing={16}
    >
      {Facility &&
        <Grid item>
          <OrderViewInformationSectionTitle>
            Facility
          </OrderViewInformationSectionTitle>
          <Typography gutterBottom>
            {splitLongWords(Facility['Company Info']['Company Name'])}
          </Typography>
          {Facility['Company Address'] && Facility['Company Address'].ID &&
            <Typography
              variant="caption"
            >
              {Facility['Company Address'].Suite}
              {` ${Facility['Company Address'].Street} Street ${Facility['Company Address'].City} ${Facility['Company Address'].State} ${Facility['Company Address']['Zip Code']}`}
            </Typography>
          }
        </Grid>
      }
      <Grid item>
        <OrderViewInformationSectionTitle>
          Transmission method
        </OrderViewInformationSectionTitle>
        <Typography>
          {otherProps['Transmission Method']}
        </Typography>
      </Grid>
    </Grid>
  </OrderViewInformationSection>
);

OrderViewInformationGeneral.propTypes = {
  'Transmission Method': PropTypes.string.isRequired,
  Facility: PropTypes.shape({
    'Company Name': PropTypes.string,
    Suite: PropTypes.string,
    Street: PropTypes.string,
    City: PropTypes.string,
    State: PropTypes.string,
    'Zip Code': PropTypes.string,
  }),
};

OrderViewInformationGeneral.defaultProps = {
  Facility: null,
};

export default OrderViewInformationGeneral;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderViewInformation/OrderViewInformationGeneral.js